module.exports = __webpack_public_path__ + "img/momo.28ce7fb2.svg";